(function(){
  'use strict';
  var sid='';
  try{sid=sessionStorage.getItem('emx_session_id')||('emx_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,8));sessionStorage.setItem('emx_session_id',sid);}catch(e){}
  window.emxTrack=window.emxTrack||function(name,payload){
    var data=Object.assign({path:location.pathname,emx_session_id:sid,timestamp:Date.now()},payload||{});
    var detail=Object.assign({event:name},data);
    window.dataLayer=window.dataLayer||[];window.dataLayer.push(detail);
    if(typeof window.gtag==='function'){try{window.gtag('event',name,data);}catch(e){}}
    try{document.dispatchEvent(new CustomEvent('emx:analytics',{detail:detail}));}catch(e){}
  };
  document.addEventListener('click',function(e){var link=e.target.closest&&e.target.closest('a');if(!link)return;var text=(link.textContent||'').trim().toLowerCase();if(text.indexOf('confirm')!==-1&&text.indexOf('compat')!==-1){window.emxTrack('emx_compatibility_confirm_click',{href:link.getAttribute('href')||''});}},true);
})();
